module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/angle-double-up-9ed2817cf710512315e5cb6cc8417176.svg";